import { useCallback } from 'react'

import { useRouter } from 'next/router'
import { useTranslations } from 'next-intl'

import { useAuthV2 } from '~/contexts/AuthContext'

import Text, { TextSizes } from '../Text/Text'

import styles from './Bookmark.module.css'

declare global {
  interface Window {
    sidebar?: {
      addPanel: (title: string, url: string, unused: string) => void
    }
    opera?: {
      [key: string]: any
    }
  }
}

interface BookmarkProps {
  url?: string
}

export default function Bookmark({ url }: BookmarkProps) {
  const t = useTranslations('bookmark')
  const router = useRouter()
  const baseUrl =
    process.env.NEXT_PUBLIC_SITE_URL || 'https://www.myartbroker.com'
  const bookmarkUrl = url || `${baseUrl}${router.asPath}`

  const handleBookmark = useCallback(() => {
    const bookmarkTitle = document.title

    if (window.sidebar && window.sidebar.addPanel) {
      // Firefox version < 23
      window.sidebar.addPanel(bookmarkTitle, bookmarkUrl, '')
    } else if (window.external && (window.external as any).AddFavorite) {
      // IE Favorite
      ;(window.external as any).AddFavorite(bookmarkUrl, bookmarkTitle)
    } else if (window.opera) {
      // Opera version >= 11.50
      const element = document.createElement('a')
      element.setAttribute('href', bookmarkUrl)
      element.setAttribute('title', bookmarkTitle)
      element.setAttribute('rel', 'sidebar')
      element.click()
    } else {
      // For other browsers
      const isMac = navigator.userAgent.toLowerCase().indexOf('mac') !== -1
      alert(t('bookmarkInstruction', { key: isMac ? 'Cmd' : 'Ctrl' }))
    }
  }, [])
  const { showAuthDialog } = useAuthV2()

  return (
    <>
      <div className={styles.container}>
        <button className={styles.bookmark} onClick={handleBookmark}>
          <svg
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 3.7C1 2.57989 1 2.01984 1.23356 1.59202C1.439 1.21569 1.76682 0.909734 2.17002 0.717987C2.6284 0.5 3.22846 0.5 4.42857 0.5H7.57143C8.77154 0.5 9.3716 0.5 9.82998 0.717987C10.2332 0.909734 10.561 1.21569 10.7664 1.59202C11 2.01984 11 2.5799 11 3.7V14L6.5 11.3334L1 14V3.7Z"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <button
          className={styles.subscribe}
          onClick={() => showAuthDialog('', true)}
        >
          <Text size={TextSizes.bodySml} className={styles.subscribeTo}>
            {t.rich('subscribeToEdition', {
              em: chunks => <em>{chunks}</em>,
            })}
          </Text>
        </button>
      </div>
    </>
  )
}
